import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPrioritySchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-priority-schemes',
	path: '/jira/settings/issues/priority-schemes',
};
